/* NCB — galerie + case d'éligibilité obligatoire (produits digitaux) */
(function () {
  function initGallery(section) {
    var main = section.querySelector('[data-ncb-main]');
    if (!main) return;
    var thumbs = section.querySelectorAll('[data-ncb-thumb]');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.getAttribute('data-src');
        main.removeAttribute('srcset');
        main.alt = btn.getAttribute('data-alt') || '';
        thumbs.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
      });
    });
  }

  function initForm(section) {
    var btn = section.querySelector('[data-ncb-submit]');
    if (!btn || btn.getAttribute('data-soldout') === 'true') return;
    var boxes = section.querySelectorAll('[data-ncb-elig]');
    if (!boxes.length) return;
    var labelOn = btn.getAttribute('data-label-on');
    var labelOff = btn.getAttribute('data-label-off');
    function sync() {
      var ok = Array.prototype.every.call(boxes, function (b) { return b.checked; });
      btn.disabled = !ok;
      btn.textContent = ok ? labelOn : labelOff;
    }
    boxes.forEach(function (b) { b.addEventListener('change', sync); });
    sync();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ncb-section]').forEach(function (s) {
      if (s.getAttribute('data-ncb-ready')) return;
      s.setAttribute('data-ncb-ready', '1');
      initGallery(s);
      initForm(s);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
